import { apiClient } from '../apiClient';

export type TrainerMessageReason = 'attendance' | 'session_materials' | 'grading' | 'other';

export const REASON_LABELS: Record<TrainerMessageReason, string> = {
  attendance: 'Attendance',
  session_materials: 'Session materials',
  grading: 'Grading',
  other: 'Other',
};

export interface TrainerMessage {
  id: string;
  batch_id: string;
  trainer_id: string;
  sender_id: string;
  reason?: TrainerMessageReason | null;
  body: string;
  created_at: string;
}

export interface TrainerMessageThreadData {
  messages: TrainerMessage[];
  self: string;
}

export const trainerMessagesApi = {
  /** trainerId is required for org admins; omit when calling as the trainer themself. */
  thread: async (batchId: string, trainerId?: string): Promise<TrainerMessageThreadData> => {
    const params: Record<string, string> = { batch_id: batchId };
    if (trainerId) params.trainer_id = trainerId;
    const { data } = await apiClient.get('/api/v1/trainer-messages', { params });
    return data as TrainerMessageThreadData;
  },
  send: async (body: {
    batch_id: string;
    trainer_id?: string;
    body: string;
    reason?: TrainerMessageReason;
  }): Promise<TrainerMessage> => {
    const { data } = await apiClient.post('/api/v1/trainer-messages', body);
    return data as TrainerMessage;
  },
};
